import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, setTokenAutoRefreshEnabled } from "firebase/app-check";
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import ReactObserver from 'react-event-observer';
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

var firebaseConfig = {};
if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;    
}

firebaseConfig = {
    apiKey: "AIzaSyAgfDJNwJFw3boHC9M7fHnBbieQxQV7MFQ",
    authDomain: "mygame.group",
    projectId: "mygamegroup-prod",
    storageBucket: "mygamegroup-prod.appspot.com",
    messagingSenderId: "216517042551",
    appId: "1:216517042551:web:333d3a03df1f6ea3dcc172"
};

const firebaseApp = initializeApp(firebaseConfig);
if (process.env.NODE_ENV === 'production') {
    const appCheck = initializeAppCheck(firebaseApp, {
        provider: new ReCaptchaEnterpriseProvider("6LfxxKEpAAAAAEYOPLc3BKXVIE19LgC8-elQL9sP"),
        isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
    });

    if (window.navigator.userAgent.includes("Safari") && !window.navigator.userAgent.includes("Chrome")) {
        setTokenAutoRefreshEnabled(appCheck, false);
    }
} else {
    console.log("turning off app check");
}

export const config = firebaseConfig;
export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
var functions = getFunctions(firebaseApp);

if (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost") {
    console.log("127.0.0.1 detected!");
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    connectAuthEmulator(auth, "http://127.0.0.1:9099");
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export const firebaseObserver = ReactObserver();
auth.onAuthStateChanged(function (user) {
    firebaseObserver.publish("authStateChanged", loggedIn())
});
export function loggedIn() {
    return !!auth.currentUser;
}